import { QueryClient } from '@tanstack/react-query';
import { TASK_COUNTS_QUERY_KEY } from '../hooks/useHomeTaskCounts';

/**
 * Invalidate task counts cache
 * Call this after mutations that affect task counts (e.g., approving orders)
 */
export function invalidateTaskCounts(queryClient: QueryClient): void {
  queryClient.invalidateQueries({ queryKey: TASK_COUNTS_QUERY_KEY });
}
